import React, {Component} from 'react'
import PropTypes from 'prop-types'
import CloseIcon from 'react-icons/lib/md/close'

import api from './helpers/api'

import Booking from './Booking'

const MAX_PEOPLE = 24
const SPOTS = {
  morning: 'Matin',
  afternoon: 'Après-midi',
}
const ACTIVITIES = ['rafting', 'hydrospeed', 'canoraft']

const peopleOptions = []
for (let i = 1; i <= MAX_PEOPLE; i++) {
  peopleOptions.push(<option key={i} value={i}>{i} personnes</option>)
}

const langOptions = [
  <option key="fr" value="fr">Français</option>,
  <option key="en" value="en">Anglais</option>,
  <option key="es" value="es">Espagnol</option>,
]

class Day extends Component {
  static propTypes = {
    bookings: PropTypes.object,
    path: PropTypes.string.isRequired,
  }

  state = {
    showForm: false,
    submitting: false,
  }

  handleToggleForm = () => {
    this.setState({
      showForm: !this.state.showForm,
      submitting: false,
    })
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const {elements} = event.target
    const name = elements.name.value.trim()
    const spot = elements.spot.value
    const activity = elements.activity.value
    const people = Number(elements.people.value)
    const email = elements.email.value.trim() || null
    const phone = elements.phone.value.trim() || null
    const lang = elements.lang.value
    const amount = Math.round(Number(elements.amount.value) * 100)
    const notes = elements.notes.value.trim() || null
    if (name && spot && people && activity) {
      this.setState({
        submitting: true,
      })
      const request = {
        path: this.props.path,
        type: spot,
        activity,
        name,
        email,
        phone,
        people,
        lang,
        amount,
        notes,
      }
      api.post('book', request)
      .then((res) => {
        if (res.email) {
          alert('Confirmation envoyée à ' + email)
        }
        this.handleToggleForm()
      })
      .catch((error) => {
        alert(error.message)
        this.setState({submitting: false})
      })
    }
  }

  renderForm = () => {
    const spotOptions = [
      <option key="none" value="" />,
      <option key="morning" value="morning">Matin</option>,
      <option key="afternoon" value="afternoon">Après-midi</option>,
    ]
    const activityOptions = [
      <option key="none" value="" />,
      <option key="rafting" value="rafting">Raft</option>,
      <option key="canoraft" value="canoraft">Canoraft (hot-dog)</option>,
      <option key="hydrospeed" value="hydrospeed">Hydrospeed</option>,
    ]

    return (
      <form className="inline book" onSubmit={this.handleSubmit}>
        <label>Nom : <br />
          <input type="text" name="name" required />
        </label>
        <label>Adresse e-mail : <br />
          <input type="email" name="email" />
        </label>
        <label>Téléphone : <br />
          <input type="text" name="phone" />
        </label>
        <label>Personnes : <br />
          <input type="number" min={1} step={1} max={MAX_PEOPLE} name="people" defaultValue={2} required />
        </label>
        <label>Créneau : <br />
          <select name="spot" required>{spotOptions}</select>
        </label>
        <label>Activité : <br />
          <select name="activity" required>{activityOptions}</select>
        </label>
        <label>Langue : <br />
          <select name="lang">{langOptions}</select>
        </label>
        <label>Payé : <br />
          <input type="number" min="0" step="0.01" name="amount" defaultValue="0" />
        </label>
        <label>Notes : <br />
          <textarea name="notes" />
        </label>
        <button type="submit" disabled={this.state.submitting}>Enregistrer</button>
        <button onClick={this.handleToggleForm} className="close"><CloseIcon /></button>
      </form>
    )
  }

  render() {
    const {bookings} = this.props

    const list = []
    Object.entries(SPOTS).forEach(([spot, label]) => {
      ACTIVITIES.forEach((activity) => {
        if (bookings[spot] && bookings[spot][activity]) {
          list.push(
            <ul key={spot + '-' + activity}>
              <h3>{label} / {activity}</h3>
              {Object.entries(bookings[spot][activity]).map(([key, data]) =>
                <Booking
                  key={key}
                  path={'bookings/' + this.props.path + '/' + spot + '/' + activity + '/' + key}
                  data={data}
                />
              )}
            </ul>
          )
        }
      })
    })
    if (!list.length) {
      list.push(<p key="none">Aucune réservation</p>)
    }

    return (
      <div className="book">
        {list}
        {this.state.showForm ? this.renderForm() : <button onClick={this.handleToggleForm}>Ajouter une réservation</button>}
      </div>
    )
  }
}

export default Day
